export default "__VITE_ASSET__80c30109__"